import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import "./tailwind.css";
import "./autumn-theme.css";
import "./halloween-theme.css";
import "./november-theme.css";

const container = document.getElementById("root");
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <div className="autumn-theme halloween-theme november-theme app-theme-root"><App /></div>
  </React.StrictMode>
);
